var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.svg)?_c('rmb',{staticClass:"rmb-svg",attrs:{"html":_vm.svg}}):_c('span',[_vm._v("¥")])
}
var staticRenderFns = []

export { render, staticRenderFns }